import type { IconSvgObject } from './types';

const ActivityCircleIcon: IconSvgObject = [
  ["path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 12H6.43381C6.78507 12 7.11058 11.8157 7.2913 11.5145L9.94366 7.0939C9.97861 7.03564 10.0416 7 10.1095 7C10.1933 7 10.2675 7.05394 10.2934 7.13362L13.42 16.7539C13.4677 16.9006 13.6045 17 13.7588 17C13.9045 17 14.0355 16.9113 14.0896 16.7761L15.7486 12.6286C15.9004 12.249 16.2681 12 16.677 12H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ActivityCircleIcon;
